import React from 'react';
import PropTypes from 'prop-types';
import ColorVariantLabelContainer from './ColorVariantLabelContainer';
import ColorTooltip from '../colorTooltipOptions/ColorTooltip';
import ColorVariantFooterTooltipOptions from './ColorVariantFooterTooltipOptions';

const ColorVariantFooter = ({ colorValue, show, showAddToFavorites }) => {
    if (!show) {
        return null;
    }

    return (
        <ColorVariantLabelContainer>
            <ColorTooltip
                colorValue={colorValue}
                showAddToFavorites={showAddToFavorites}
                closeOnScroll
            >
                <ColorVariantFooterTooltipOptions
                    colorValue={colorValue}
                    showAddToFavorites={showAddToFavorites}
                />
            </ColorTooltip>
        </ColorVariantLabelContainer>
    );
};

ColorVariantFooter.propTypes = {
    show: PropTypes.bool,
    colorValue: PropTypes.string,
    showAddToFavorites: PropTypes.bool,
};

ColorVariantFooter.defaultProps = {
    show: false,
    showAddToFavorites: false,
    colorValue: undefined,
};

export default ColorVariantFooter;
